import request from '@/axios/request.js'

import { requestConfig } from '@/api/index.js'

export const uploadURL = `${requestConfig.url}/api/api/upload`;

// export function uploadData () {
//   return request({
//     url: '/api/api/upload',
//     method: ''
//   })
// }
// 获取城市列表
export function getCityData () {
  return request({
    url: '/mall/city_list',
    method: 'get'
  })
}

// 获取委托方列表
export function getClientList (params) {
  // params = {  // 分页信息
  //   page: 1,
  //   limit: 1
  // }
  return request({
    url: '/mall/client/all',
    method: 'get',
    params
  })
}

// 获取委托方详细信息
export function getClientDetail (id) {
  return request({
    url: `/mall/client/detail/${id}`,
    method: 'get'
  })
}

// 编辑（带id）/新增（不带id）委托方信息
export function editClient (data) {
  // data = {
  //   "id":"1",  // id，在编辑时传入
  //   "clientName":"北矿检测3",  // 委托方名称
  //   "bankName":"bankName",  // 开户行
  //   "bankAccount":"bankAccount",  // 账号
  //   "taxNumber":"taxNumber",  // 税号
  //   "industryType":"industryType",  // 行业类型
  //   "region":"region",  // 地域
  //   "invoicingType":"invoicingType"  // 开票类型
  // }
  return request({
    url: '/mall/client/edit',
    method: 'post',
    data
  })
}

// 删除委托方信息
export function delClient (data) {
  return request({
    url: '/mall/client/del',
    method: 'post',
    data
  })
}

// 获取联系人列表
export function getAddressData (params) {
  // params = {  // 分页信息
  //   page: 1,
  //   limit: 1
  // }
  return request({
    url: '/mall/address/list',
    method: 'get',
    params
  })
}

// 获取传入id列表对应的联系人列表
export function getAddressDetail (ids) {
  return request({
    url: `/mall/address/detail/list/${ids}`,
    method: 'get'
  })
}

// 获取指定委托方下联系人信息
export function getClientAddressData (id, params) {
  // params = {  // 分页信息
  //   page: 1,
  //   limit: 1
  // }
  return request({
    url: `/mall/address/client/${id}`,
    method: 'get',
    params
  })
}

// 设置默认联系人
export function setDefaultAddress (data) {
  // data = {
  //   id: '37'  // 联系人id
  // }
  return request({
    url: '/mall/address/default/set',
    method: 'post',
    data
  })
}

// 获取默认联系人
export function getDefaultAddress () {
  return request({
    url: '/mall/address/default',
    method: 'get'
  })
}

// 编辑（带id）/新增（不带id）联系人
export function editAddressData (data) {
  // data = {
  //   "id": "37",  // id，在编辑时传入
  //   "real_name": "real_name",  // 联系人姓名
  //   "post_code": "123",  // 邮编
  //   "is_default": "false",  // 是否为默认
  //   "detail": "三里屯999号",  // 详细住址
  //   "phone": "13058741057",  // 联系电话
  //   "address": {  // 地址选择
  //     "city_id": 1692,
  //     "city": "北京市",
  //     "district": "海淀区",
  //     "province": "北京市"
  //   },
  //   "company": "北矿2",  // 委托方名称
  //   "fax": "110-110-110",  // 传真
  //   "email": "aabbcc@mail.com",  // email
  //   "delivery": [  // 报告获取方式
  //     "1",
  //     "3"
  //   ],
  //   "clientId": 1  // 委托方id
  // }
  return request({
    url: '/mall/address/edit',
    method: 'post',
    data
  })
}

// 删除联系人信息
export function deleteAddress (data) {
  // data = {
  //   "id": "37"  // 联系人id
  // }
  return request({
    url: '/mall/address/del',
    method: 'post',
    data
  })
}

// 查询手机号是否为注册账户
export function checkUserByPhone (phone) {
  return request({
    url: `/mall/user/check/phone/${phone}`,
    method: 'get'
  })
}

// 通过用户名判断此用户是否存在
export function checkUserByUserName (userName) {
  return request({
    url: `/mall/user/check/userName/${userName}`,
    method: 'get'
  })
}
// 通过用户名获取用户信息
export function getUserByUserName (userName) {
  return request({
    url: `/mall/user/get/userName/${userName}`,
    method: 'get'
  })
}

// 修改密码
export function changePassword (data) {
  // data = {
  //   username: '',  // 用户名
  //   password: '',  // 原密码
  //   newPassword: ''  // 现密码
  // }
  return request({
    url: '/auth/oauth/password/change',
    method: 'post',
    data
  })
}

// 获取收藏、足迹
export function getCollectData (params) {
  return request({
    url: '/mall/collect/user',
    method: 'get',
    params
  })
}

// 添加收藏、足迹
export function addCollection (data) {
  return request({
    url: '/mall/collect/add',
    method: 'post',
    data
  })
}

// 删除收藏、足迹
export function deleteCollection (data) {
  return request({
    url: '/mall/collect/del',
    method: 'post',
    data
  })
}

// 批量删除足迹
export function deleteAllCollection (data) {
  return request({
    url: '/mall/collect/delFoot',
    method: 'delete',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js